const preventSubmitOnEnter = (e) => {
  const keyCode = e.keyCode || e.which;

  if (keyCode === 13 && e.target.tagName !== 'TEXTAREA') {
    e.preventDefault();
  }
};

export default preventSubmitOnEnter;
